var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"html-content",class:{ 'html-content--small': _vm.isSmall }},[_c('div',{staticClass:"sun-editor-editable",domProps:{"innerHTML":_vm._s(_vm.html)}}),_vm._v(" "),(_vm.ytbMatcher)?_c('EmbeddedVideo',{ref:"youtube",staticClass:"mx-auto",attrs:{"video-id":_vm.ytbMatcher[1]}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }